import { render, staticRenderFns } from "./TifSitiosIndex.vue?vue&type=template&id=79a61be4"
import script from "./TifSitiosIndex.vue?vue&type=script&lang=js"
export * from "./TifSitiosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports